(function () {
  const config = window.autoGiftConfig;
  if (!config || !config.giftVariantId) return;

  const ROOT = (config.root || '/').replace(/\/$/, '');
  const GIFT_PROPERTY = '_auto_gift';
  const DECLINED_KEY = 'auto-gift-declined';
  const SOURCE_ID = 'auto-gift';
  const CART_ENDPOINTS = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  const nativeFetch = window.fetch.bind(window);

  let syncing = false;
  let queued = false;
  let lastHadGift = null;

  // ---------- helpers ----------

  function isExpired() {
    if (!config.endDate) return false;
    const end = Date.parse(config.endDate);
    return !isNaN(end) && Date.now() > end;
  }

  function isDeclined() {
    try { return sessionStorage.getItem(DECLINED_KEY) === '1'; } catch (e) { return false; }
  }

  function setDeclined(value) {
    try {
      if (value) sessionStorage.setItem(DECLINED_KEY, '1');
      else sessionStorage.removeItem(DECLINED_KEY);
    } catch (e) {}
  }

  function jsonRequest(url, body) {
    return nativeFetch(ROOT + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
  }

  async function getCart() {
    const res = await nativeFetch(ROOT + '/cart.js', { headers: { Accept: 'application/json' } });
    return res.json();
  }

  // Only the gift line added by this script (marked with the hidden property)
  function findGiftLine(cart) {
    return cart.items.find(
      (item) => item.variant_id === config.giftVariantId && item.properties && item.properties[GIFT_PROPERTY]
    );
  }

  function hasTriggerProduct(cart) {
    return cart.items.some((item) => config.triggerProductIds.includes(item.product_id));
  }

  // Tell Horizon's cart drawer / bubble to re-render; full reload on the cart page as a fallback
  function refreshCartUI(cart) {
    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cart,
          sourceId: SOURCE_ID,
          data: { source: SOURCE_ID, itemCount: cart.item_count }
        }
      })
    );

    if (/\/cart\/?$/.test(window.location.pathname)) {
      window.location.reload();
    }
  }

  // ---------- main sync ----------

  async function sync() {
    if (syncing) {
      queued = true;
      return;
    }
    syncing = true;

    try {
      let cart = await getCart();
      const giftLine = findGiftLine(cart);
      const hasTrigger = hasTriggerProduct(cart);
      let changed = false;

      // Customer removed the gift themselves while a trigger product is still in the cart
      if (lastHadGift && !giftLine && hasTrigger) setDeclined(true);

      // Reset the decline once the trigger products are gone
      if (!hasTrigger) setDeclined(false);

      if (isExpired() || !hasTrigger) {
        if (giftLine) {
          await jsonRequest('/cart/change.js', { id: giftLine.key, quantity: 0 });
          changed = true;
        }
      } else if (!giftLine && !isDeclined()) {
        await jsonRequest('/cart/add.js', {
          items: [{ id: config.giftVariantId, quantity: 1, properties: { [GIFT_PROPERTY]: 'true' } }]
        });
        changed = true;
      } else if (giftLine && giftLine.quantity > 1) {
        // The discount only covers one gift
        await jsonRequest('/cart/change.js', { id: giftLine.key, quantity: 1 });
        changed = true;
      }

      if (changed) {
        cart = await getCart();
        refreshCartUI(cart);
      }

      lastHadGift = Boolean(findGiftLine(cart));
    } catch (error) {
      console.warn('Auto gift sync failed:', error);
    } finally {
      syncing = false;
      if (queued) {
        queued = false;
        sync();
      }
    }
  }

  // ---------- listen to every cart change made by the theme or apps ----------

  window.fetch = function (input, init) {
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    const request = nativeFetch(input, init);

    if (CART_ENDPOINTS.test(url)) {
      request.then(() => setTimeout(sync, 100)).catch(() => {});
    }

    return request;
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
})();